import { render, staticRenderFns } from "./StartAuthorizationCodeView.vue?vue&type=template&id=16761e0e&"
import script from "./StartAuthorizationCodeView.vue?vue&type=script&lang=js&"
export * from "./StartAuthorizationCodeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports